import { useCallback } from 'react';

import { useIsCustomerSessionReady } from '@order/hooks';

import { useOrdersQuery } from '../GraphQL/Orders.generated';
import { ORDERS_QUERY_VARIABLES } from './constants';

export const useOrders = () => {
  const [ordersResponse, reFetchOrders] = useOrdersQuery({
    variables: ORDERS_QUERY_VARIABLES,
    requestPolicy: 'cache-and-network',
    pause: true,
  });

  // Only allow fetching orders if the customer's session is ready.
  const isCustomerSessionReady = useIsCustomerSessionReady();
  const fetchOrders = useCallback(() => {
    if (isCustomerSessionReady) reFetchOrders();
  }, [isCustomerSessionReady, reFetchOrders]);

  const ordersResponseData = ordersResponse.data?.orders;
  const isSuccess = ordersResponseData?.__typename === 'OrdersResponseSuccess';
  const hasErrorOrders = ordersResponseData?.__typename === 'ValidationError';
  const isLoadingOrders = ordersResponse.fetching || ordersResponse.stale;
  const isFetchingOrders = ordersResponse.fetching;
  const orders = isSuccess ? ordersResponseData.orders : [];

  return {
    orders,
    isLoadingOrders,
    isFetchingOrders,
    hasErrorOrders,
    fetchOrders,
  };
};
